import { ReactElement } from 'react'
import FloatingMessage from './FloatingMessage'
import GradientCircularProgress from './GradientCircularProgress'
import { I18n, Translate } from 'common'
import { observer } from 'mobx-react-lite'
import { useResultsStore } from '../../../store/ResultsStore'
import { StoreInstances } from '../../../../../../src/store/StoreInstancesContainer'

interface Props {
  totalResults: number
}

/* 
  Due to an API limitation, the interchange search (Non-cached search only)
  doesn't support sorting by Cost, Availability or List and thus the user has to manually
  click a sort option after results are loaded
*/
const LoadingMessage = observer((props: Props): ReactElement => {
  const { totalResults } = props
  const resultsStore = useResultsStore()

  const title = Translate('loadingXResults', [totalResults ?? 0])

  const notSupported = (i) =>
    i.label?.includes('Cost') ||
    i.label?.includes('Availability') ||
    i.label?.includes('List')

  const showSortMessage =
    resultsStore.sortOrder?.filter(notSupported)?.length > 0

  const sortHasNotYetBeenApplied = <I18n name="sortHasNotYetBeenApplied" />

  const message = showSortMessage ? <div>{sortHasNotYetBeenApplied}</div> : null

  const icon = (
    <GradientCircularProgress
      primaryColor="#FFC800"
      secondaryColor="#FFF4CC"
      thickness={6}
      size={'40px'}
    />
  )

  return (
    <FloatingMessage
      title={title}
      message={message}
      icon={icon}
      visible={StoreInstances.uiStore.showMonitoringPricesMessage}
    />
  )
})

export default LoadingMessage
